import { Box, Button, Heading, Text, VStack } from "@chakra-ui/react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <VStack spacing={6} textAlign="center">
        <Heading fontSize="6xl" color="red.500">
          404
        </Heading>
        <Text fontSize="xl">Ops! Página não encontrada.</Text>
        <Text>O link que você acessou pode estar incorreto, a página pode ter sido removida ou você não tem acesso.</Text>
      </VStack>
    </Box>
  );
}
